export default __webpack_public_path__ + "static/media/010207202145103.76efca5e.png";